/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Reset_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Reset all video filters" |
*
* @param {Video_Filters_Reset_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_reset_aria_label = /** @type {((inputs?: Video_Filters_Reset_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Reset_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reinitialiser tous les filtres video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Videofilter zurücksetzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reimposta tutti i filtri video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сбросить все видеофильтры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restablecer todos los filtros de vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重置所有视频滤镜")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのビデオフィルターをリセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी वीडियो फ़िल्टर रीसेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Redefinir todos os filtros de vídeo")
	return /** @type {LocalizedString} */ ("Reset all video filters")
});